import { useEffect, useState } from "react";
import ExoForm from "../../exo/ExoForm";
import { filterElements } from "./filterElements";
import { Box, IconButton } from "@mui/material";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

export const MapFilter = ({ setFilter, filter }) => {
  const [fields, setFields] = useState([]);
  useEffect(() => {
    if (fields.length === 0) setFields(generateFields());
  }, []);

  // Stable snapshot of the filter state used to initialize the form. It must NOT
  // change by reference after mount: ExoForm re-syncs its internal state on every
  // startDataCollection change, so feeding the live filter back in would loop.
  // When no filter is active yet (everything shown) the type checkboxes start
  // CHECKED, so "checked = visible" and unchecking a box hides that type.
  const [initialData] = useState(() =>
    filter || { edge: true, node: true }
  );

  function generateFields() {
    var newFields = [];
    newFields.push({ type: "label", label: "Asset Types" });
    filterElements.mapElements.filter.forEach((filter) => {
      newFields.push({ ...filter });
    });
    newFields.push({
      type: "divider",
    });
    newFields.push({ type: "label", label: "Asset Properties" });
    return newFields;
  }

  return (
    <Box className="relative" sx={{ minWidth: "160px" }}>
      <IconButton
        className="top-0 right-0"
        onClick={() => setFilter(null)}
        sx={{ position: "absolute" }}
      >
        <FilterAltOffIcon />
      </IconButton>
      <ExoForm
        noDifferences
        noControls
        startDataCollection={initialData}
        className="gap-2"
        fields={fields}
        // Apply the filter live as checkboxes are toggled, no submit needed.
        // Ignore the transient empty state ExoForm emits before it syncs the
        // initial data (toggling always writes an explicit true/false, so a real
        // selection is never empty), which would otherwise flash everything off.
        onChange={(data) => {
          if (Object.keys(data).length) setFilter(data);
        }}
      />
    </Box>
  );
};
